const makePlural = (quantity: number, noun: string) => {
    return noun + (quantity === 1 ? "" : "s");
}

export default makePlural;